import 'whatwg-fetch';
import { settings as raySettings } from '@wework/ray-core';
import WeGlide from 'client/javascript/we_glide/we_glide';
import { initializeSaveButtons, setupSaveListener } from 'client/shared/save_hearts';
import { logError } from 'client/javascript/util/logger';

const workspacesListSelector = '.nearby-buildings-slider__cards';
const preloaderSelector = '.nearby-buildings__loader-container';
const sliderContainerId = 'nearby-buildings-slider';
const saveButtonSelector = '.nearby-buildings-slider__card-heart-icon';
const slidesListSelector = `#${sliderContainerId} .glide__slides`;
const buildingLinkSelector = '.nearby-buildings-slider__card--link';
const firstSliderArrowSelector = '.slider__arrow-btn--right';
const containerId = 'nearby-buildings';

const nearbyBuildingsSliderOptions = {
  perView: 3,
  bound: true,
  breakpoints: {
    [raySettings.breakpointsInPixels.tablet]: {
      perView: 1,
      peek: {
        before: 0,
        after: 11
      },
      gap: 16
    },
    [raySettings.breakpointsInPixels.desktop]: {
      gap: 24,
      perView: 2
    }
  }
};

let glide = null;

function isSliderFitOnScreen(slidesListContainer) {
  return window.screen.width >= slidesListContainer.clientWidth;
}

function removeSliderArrowIfAFewSlides() {
  const sliderContainer = document.getElementById(sliderContainerId);
  const firstArrowElement = sliderContainer.querySelector(firstSliderArrowSelector);

  if (firstArrowElement) {
    firstArrowElement.style.display = 'none';
  }
}

export function toggleSliderInit() {
  const sliderContainer = document.getElementById(sliderContainerId);

  if (sliderContainer == null) {
    return null;
  }

  initializeSaveButtons(buildingLinkSelector);
  setupSaveListener(slidesListSelector, saveButtonSelector);

  glide = new WeGlide(`#${sliderContainerId}`, nearbyBuildingsSliderOptions);
  glide.mount();

  const cardsCount = sliderContainer.getElementsByTagName('li').length;
  const slidesListContainer = sliderContainer.querySelector(slidesListSelector);

  if (cardsCount <= 3 && isSliderFitOnScreen(slidesListContainer)) {
    removeSliderArrowIfAFewSlides();
  }
}

function hideNearbyBuildingsModule() {
  const containerElement = document.getElementById(containerId);
  if (containerElement) {
    containerElement.style.display = 'none';
  }
}

function showNearbyBuildingsModule() {
  const containerElement = document.getElementById(containerId);
  const preloaderEl = document.querySelector(preloaderSelector);

  containerElement.style.display = 'block';

  if (preloaderEl) {
    preloaderEl.parentNode.removeChild(preloaderEl);
  }
}

export function setupNearbyBuildingsSectionModule(currentProductData, callback) {
  try {
    if (glide) {
      glide.destroy();
      glide = null;
    }

    const buildingsContainer = document.querySelector(workspacesListSelector);

    if (currentProductData == null || currentProductData.buildingsListHTML == null || !buildingsContainer) {
      return hideNearbyBuildingsModule();
    }

    buildingsContainer.innerHTML = currentProductData.buildingsListHTML;

    showNearbyBuildingsModule();
    toggleSliderInit();

    if (typeof callback === 'function') {
      callback();
    }
  } catch (error) {
    logError(`[Shared modules] setupNearbyBuildingsSectionModule failed: ${error.message}`, error);
  }
}
